/** Converts degrees to radians. */
export function degToRad(degrees) {
  return degrees * (Math.PI / 180);
}